(function () {
'use strict';
function init(root) {
if (!root || root.__bcInit) return;
root.__bcInit = true;
var form         = root.querySelector('[data-bc-form]');
var sidebar      = root.querySelector('[data-bc-sidebar]');
var gridWrap     = root.querySelector('[data-bc-grid-wrap]');
var sortInput    = root.querySelector('[data-bc-sort-input]');
var collectionUrl = root.getAttribute('data-bc-url') || window.location.pathname;
var debounceTimer = null;
function debounce(fn, ms) {
clearTimeout(debounceTimer);
debounceTimer = setTimeout(fn, ms);
}
function buildSearchParams() {
if (!form) return '';
var fd = new FormData(form);
var params = new URLSearchParams();
fd.forEach(function (value, key) {
if (value === '' || value == null) return;
params.append(key, value);
});
return params.toString();
}
function fetchAndSwap(pushState) {
if (!gridWrap) return;
var qs = buildSearchParams();
var sectionId = root.id.replace(/^bc-/, '');
var url = collectionUrl + '?section_id=' + encodeURIComponent(sectionId) + (qs ? '&' + qs : '');
var historyUrl = collectionUrl + (qs ? '?' + qs : '');
gridWrap.classList.add('is-loading');
fetch(url, { headers: { 'Accept': 'text/html' } })
.then(function (r) { return r.text(); })
.then(function (html) {
var parser  = new DOMParser();
var doc     = parser.parseFromString(html, 'text/html');
var newRoot = doc.querySelector('#' + root.id) || doc.querySelector('[data-bc-section]');
if (!newRoot) { gridWrap.classList.remove('is-loading'); return; }
var newGridWrap = newRoot.querySelector('[data-bc-grid-wrap]');
var newSidebar  = newRoot.querySelector('[data-bc-sidebar]');
var newSummary  = newRoot.querySelector('[data-bc-summary]');
var newSort     = newRoot.querySelector('.bc__sort');
if (newGridWrap && gridWrap) gridWrap.innerHTML = newGridWrap.innerHTML;
if (newSidebar && sidebar)   sidebar.innerHTML  = newSidebar.innerHTML;
var summary = root.querySelector('[data-bc-summary]');
if (newSummary && summary)   summary.innerHTML  = newSummary.innerHTML;
var sort = root.querySelector('.bc__sort');
if (newSort && sort)         sort.innerHTML     = newSort.innerHTML;
if (pushState !== false) {
window.history.replaceState({}, '', historyUrl);
}
gridWrap.classList.remove('is-loading');
attachDynamicHandlers();
})
.catch(function () { gridWrap.classList.remove('is-loading'); });
}
function attachDynamicHandlers() {
var inputs = root.querySelectorAll('[data-bc-filter-input]');
inputs.forEach(function (input) {
input.addEventListener('change', function () { debounce(fetchAndSwap, 80); });
});
var sortPills = root.querySelectorAll('[data-bc-sort]');
sortPills.forEach(function (pill) {
pill.addEventListener('click', function () {
var val = pill.getAttribute('data-bc-sort-value');
var existing = form.querySelector('[data-bc-sort-input]');
if (existing) {
existing.value = val;
} else {
var hidden = document.createElement('input');
hidden.type = 'hidden';
hidden.name = 'sort_by';
hidden.value = val;
hidden.setAttribute('data-bc-sort-input', '');
form.prepend(hidden);
}
fetchAndSwap();
});
});
var removeBtns = root.querySelectorAll('[data-bc-remove]');
removeBtns.forEach(function (btn) {
btn.addEventListener('click', function () {
var url = btn.getAttribute('data-bc-remove');
if (!url) return;
var qs = url.split('?')[1] || '';
window.history.replaceState({}, '', collectionUrl + (qs ? '?' + qs : ''));
syncFormFromUrl(qs);
fetchAndSwap(false);
});
});
initPriceSlider();
var presets = root.querySelectorAll('[data-bc-price-preset]');
presets.forEach(function (btn) {
btn.addEventListener('click', function () {
var min = btn.getAttribute('data-min');
var max = btn.getAttribute('data-max');
var minInput = root.querySelector('[data-bc-price-input-min]');
var maxInput = root.querySelector('[data-bc-price-input-max]');
if (minInput) minInput.value = min;
if (maxInput) maxInput.value = max;
presets.forEach(function (p) { p.classList.remove('is-active'); });
btn.classList.add('is-active');
fetchAndSwap();
});
});
}
function syncFormFromUrl(qs) {
if (!form) return;
var params = new URLSearchParams(qs);
form.querySelectorAll('input[type="checkbox"][name^="filter."]').forEach(function (i) { i.checked = false; });
form.querySelectorAll('input[type="number"][name^="filter."]').forEach(function (i) { i.value = ''; });
params.forEach(function (val, key) {
var inputs = form.querySelectorAll('[name="' + CSS.escape(key) + '"]');
inputs.forEach(function (input) {
if (input.type === 'checkbox') {
if (input.value === val) input.checked = true;
} else {
input.value = val;
}
});
});
}
function initPriceSlider() {
var slider = root.querySelector('[data-bc-price-slider]');
if (!slider || slider.__bcSlider) return;
slider.__bcSlider = true;
var min   = Number(slider.getAttribute('data-min')) || 0;
var max   = Number(slider.getAttribute('data-max')) || 1000;
var vMin  = Number(slider.getAttribute('data-value-min')) || min;
var vMax  = Number(slider.getAttribute('data-value-max')) || max;
var fill  = slider.querySelector('[data-bc-price-fill]');
var hMin  = slider.querySelector('[data-bc-price-handle-min]');
var hMax  = slider.querySelector('[data-bc-price-handle-max]');
var iMin  = root.querySelector('[data-bc-price-input-min]');
var iMax  = root.querySelector('[data-bc-price-input-max]');
var dMin  = root.querySelector('[data-bc-price-min-display]');
var dMax  = root.querySelector('[data-bc-price-max-display]');
var bars  = root.querySelectorAll('.bc__price-bar');
function pct(v) {
if (max <= min) return 0;
return ((v - min) / (max - min)) * 100;
}
function clamp(n, lo, hi) { return Math.max(lo, Math.min(hi, n)); }
function paint() {
var loRaw = pct(vMin), hiRaw = pct(vMax);
var lo = clamp(loRaw, 0, 100);
var hi = clamp(hiRaw, lo, 100);
if (fill) {
fill.style.left = lo + '%';
fill.style.right = (100 - hi) + '%';
}
if (hMin) hMin.style.left = lo + '%';
if (hMax) hMax.style.left = hi + '%';
if (dMin) dMin.textContent = Math.round(vMin);
if (dMax) dMax.textContent = Math.round(vMax);
bars.forEach(function (bar, i) {
var barPct = (i + 0.5) / bars.length * 100;
bar.classList.toggle('is-active', barPct >= lo && barPct <= hi);
});
}
paint();
var dragging = null;
function onPointerDown(which) {
return function (e) {
dragging = which;
e.preventDefault();
window.addEventListener('pointermove', onPointerMove);
window.addEventListener('pointerup', onPointerUp);
};
}
function onPointerMove(e) {
if (!dragging) return;
var rect = slider.getBoundingClientRect();
if (!rect.width) return;
var x = Math.max(0, Math.min(rect.width, e.clientX - rect.left));
var ratio = x / rect.width;
var value = Math.round(min + (max - min) * ratio);
value = clamp(value, min, max);
if (dragging === 'min') {
vMin = clamp(value, min, vMax - 1);
} else {
vMax = clamp(value, vMin + 1, max);
}
paint();
}
function onPointerUp() {
if (!dragging) return;
dragging = null;
window.removeEventListener('pointermove', onPointerMove);
window.removeEventListener('pointerup', onPointerUp);
if (iMin) iMin.value = Math.round(vMin);
if (iMax) iMax.value = Math.round(vMax);
fetchAndSwap();
}
if (hMin) hMin.addEventListener('pointerdown', onPointerDown('min'));
if (hMax) hMax.addEventListener('pointerdown', onPointerDown('max'));
}
var openBtn  = root.querySelector('[data-bc-drawer-open]');
var backdrop = document.createElement('div');
backdrop.className = 'bc__backdrop';
document.body.appendChild(backdrop);
function openDrawer() {
sidebar.classList.add('is-open');
backdrop.classList.add('is-open');
document.body.style.overflow = 'hidden';
}
function closeDrawer() {
sidebar.classList.remove('is-open');
backdrop.classList.remove('is-open');
document.body.style.overflow = '';
}
if (openBtn) openBtn.addEventListener('click', openDrawer);
backdrop.addEventListener('click', closeDrawer);
document.addEventListener('keydown', function (e) {
if (e.key === 'Escape') closeDrawer();
});
root.addEventListener('submit', function (e) {
var f = e.target;
if (!f.matches('[data-bc-add-form]')) return;
e.preventDefault();
var btn = f.querySelector('button[type="submit"]');
if (btn) btn.disabled = true;
var fd = new FormData(f);
fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
.then(function (r) { return r.json(); })
.then(function () {
document.dispatchEvent(new CustomEvent('cart:refresh'));
window.dispatchEvent(new CustomEvent('cart:add', { detail: { source: 'booster-collection' } }));
if (btn) {
var label = btn.querySelector('span');
if (label) {
var prev = label.textContent;
label.textContent = '✓';
setTimeout(function () { label.textContent = prev; btn.disabled = false; }, 1200);
} else {
btn.disabled = false;
}
}
})
.catch(function () { if (btn) btn.disabled = false; });
});
attachDynamicHandlers();
}
function bootstrap() {
document.querySelectorAll('[data-bc-section]').forEach(init);
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', bootstrap);
} else {
bootstrap();
}
document.addEventListener('shopify:section:load', function (e) {
var s = e.target.querySelector('[data-bc-section]');
if (s) init(s);
});
})();
